import { combineReducers } from 'redux';
import charactersReducer from './characters';
import characterDetailsReducer from './characterDetails';
import comicsReducer from './comics';
import comicDetailsReducer from './comicDetails';
import storiesReducer from './stories';
import storyDetailsReducer from './storyDetails';
import bookmarksReducer from './bookmarks';
import hidenItemsReducer from './hidenItems';

const rootReducer = combineReducers({
  characters: charactersReducer,
  characterDetails: characterDetailsReducer,
  comics: comicsReducer,
  comicDetails: comicDetailsReducer,
  stories: storiesReducer,
  storyDetails: storyDetailsReducer,
  bookmarks: bookmarksReducer,
  hidenItems: hidenItemsReducer,
});

export default rootReducer;
